/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { PageOfRuleSet } from '@coin/shared/core/util-models-v2';
import { RuleEngineUploadedGidsValidationRequest } from '@coin/shared/core/util-models-v2';
import { RuleSet } from '@coin/shared/core/util-models-v2';
import { UploadedGidsValidationResult } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CreateRuleSetsParams {
  /** The data to create the new ruleset with. */
  ruleSet?: RuleSet;
}

export interface DeleteRuleSetsParams {
  /** The unique id of the ruleset to delete. */
  id: string;
}

export interface GetByIdRuleSetsParams {
  /** The rulesets unique id. */
  id: string;
}

export interface GetRuleSetsParams {
  page?: number;
  size?: number;
}

export interface UpdateRuleSetsParams {
  /** The unique id of the ruleset tso update. */
  id: string;
  /** The data to update the ruleset with. */
  ruleSet?: RuleSet;
}

export interface ValidateRuleSetsParams {
  ruleEngineUploadedGidsValidationRequest?: RuleEngineUploadedGidsValidationRequest;
}

@Injectable({
  providedIn: 'root'
})
export class RuleEngineService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * Creates a new ruleset with provided data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createRuleSets(
    requestParameters?: CreateRuleSetsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RuleSet>;
  public createRuleSets(
    requestParameters?: CreateRuleSetsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RuleSet>>;
  public createRuleSets(
    requestParameters?: CreateRuleSetsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RuleSet>>;
  public createRuleSets(requestParameters?: CreateRuleSetsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/rule-sets`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Deletes an existing ruleset.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteRuleSets(
    requestParameters?: DeleteRuleSetsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public deleteRuleSets(
    requestParameters?: DeleteRuleSetsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public deleteRuleSets(
    requestParameters?: DeleteRuleSetsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public deleteRuleSets(requestParameters?: DeleteRuleSetsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteRuleSets', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v2/rule-sets/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets a ruleset by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByIdRuleSets(
    requestParameters?: GetByIdRuleSetsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RuleSet>;
  public getByIdRuleSets(
    requestParameters?: GetByIdRuleSetsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RuleSet>>;
  public getByIdRuleSets(
    requestParameters?: GetByIdRuleSetsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RuleSet>>;
  public getByIdRuleSets(requestParameters?: GetByIdRuleSetsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getByIdRuleSets', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/rule-sets/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets existing rulesets.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRuleSets(
    requestParameters?: GetRuleSetsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRuleSet>;
  public getRuleSets(
    requestParameters?: GetRuleSetsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRuleSet>>;
  public getRuleSets(
    requestParameters?: GetRuleSetsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRuleSet>>;
  public getRuleSets(requestParameters?: GetRuleSetsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/rule-sets`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * Updates an existing ruleset with provided data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateRuleSets(
    requestParameters?: UpdateRuleSetsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RuleSet>;
  public updateRuleSets(
    requestParameters?: UpdateRuleSetsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RuleSet>>;
  public updateRuleSets(
    requestParameters?: UpdateRuleSetsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RuleSet>>;
  public updateRuleSets(requestParameters?: UpdateRuleSetsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateRuleSets', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/rule-sets/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Validates gid uploads.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validateRuleSets(
    requestParameters?: ValidateRuleSetsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<UploadedGidsValidationResult>>;
  public validateRuleSets(
    requestParameters?: ValidateRuleSetsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<UploadedGidsValidationResult>>>;
  public validateRuleSets(
    requestParameters?: ValidateRuleSetsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<UploadedGidsValidationResult>>>;
  public validateRuleSets(requestParameters?: ValidateRuleSetsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/rule-sets/validate-gid-uploads`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.ruleEngineUploadedGidsValidationRequest,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
